<template>
  <div>
    <h3 class="text-center mb-4 mt-4">已报备项目</h3>
    <div class="page-title-desc text-center mb-4 mt-4">查看已报备项目结果、有效期，如有疑问请联系 010-64361972</div>
    <page-body>
      <report-project-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import reportProjectList from './components/List'

export default {
  name: 'reportProject',
  components: {
    reportProjectList,
  },
  data () {
    return {
      listId: 'reportProjectList',
    }
  },
}
</script>
<style lang="scss" scoped>
  .page-title-desc {
    color: #5F6368;
    font-size: 16px;
  }
</style>
